'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconIndeterminantCheckbox, iconIndeterminantCheckboxTag } from '@ni/nimble-components/dist/esm/icons/indeterminant-checkbox';
import { wrap } from '../../utilities/react-wrapper';

export type { IconIndeterminantCheckbox };
export { iconIndeterminantCheckboxTag };
export const NimbleIconIndeterminantCheckbox = wrap(IconIndeterminantCheckbox);